import { render, staticRenderFns } from "./KirmiziSantralExtensions.vue?vue&type=template&id=78b1847a&scoped=true"
import script from "./KirmiziSantralExtensions.vue?vue&type=script&lang=js"
export * from "./KirmiziSantralExtensions.vue?vue&type=script&lang=js"
import style0 from "./KirmiziSantralExtensions.vue?vue&type=style&index=0&id=78b1847a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b1847a",
  null
  
)

export default component.exports